import { useState } from "react";
import styles from "../Shared/CommonFields.module.css";
import { Collapsible, FormLayout } from "@shopify/polaris";
import { MdOutlineArrowBackIosNew } from "react-icons/md";
import { useFormContext, useWatch } from "react-hook-form";
import useBundleMixpanelHook from "../../../../hooks/useBundleMixpanelHook";
import { FormTextField, FormCheckbox, FormNumberField } from "../../../../components/FormFields";

type Props_BundleInfo = {
    bundleType?: string;
};

const BundleInfo = ({ bundleType = "volume" }: Props_BundleInfo) => {
    const [expandBundleInfo, setExpandBundleInfo] = useState(true);
    const { trackFormSections } = useBundleMixpanelHook();
    const { control } = useFormContext();

    const showCountdownTimer = useWatch({ control, name: "show_countdown_timer" });

    return (
        <>
            <div
                className={styles.sectionTitleWrapper}
                onClick={() =>
                    setExpandBundleInfo((ps) => {
                        trackFormSections({
                            cta: "Form Section",
                            ctaType: `Bundle Info ${ps ? "Collapsed" : "Expanded"}`,
                            bundleType: bundleType,
                        });
                        return !ps;
                    })
                }
            >
                <div>Bundle Info</div>

                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        transform: expandBundleInfo ? "rotate(90deg)" : "rotate(270deg)",
                    }}
                >
                    <MdOutlineArrowBackIosNew size={14} />
                </div>
            </div>
            <Collapsible
                open={expandBundleInfo}
                id="bundle-info-collapsible"
                transition={{
                    duration: "500ms",
                    timingFunction: "ease-in-out",
                }}
                expandOnPrint
            >
                <FormLayout>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "8px",
                        }}
                    >
                        <FormTextField
                            name="title"
                            label="Title"
                            placeholder="Title"
                            maxLength={80}
                            showCharacterCount
                        />

                        <FormTextField
                            name="offer_name"
                            label="Offer Name"
                            placeholder="Offer name"
                            helpText="This name is only visible to you. It helps you identify the bundle."
                            maxLength={80}
                            showCharacterCount
                        />

                        <FormCheckbox label="Show line around title" name="show_line_around_title" />

                        <FormCheckbox label="Show countdown timer" name="show_countdown_timer" />

                        {showCountdownTimer && (
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "10px",
                                    padding: "10px",
                                    borderRadius: "8px",
                                    backgroundColor: "#f9f9f9",
                                }}
                            >
                                <FormTextField
                                    name="countdown_timer_text"
                                    label="Timer Text"
                                    placeholder="The offer is going to expire soon in {timer}, hurry up!"
                                    helpText="Use {timer} to show countdown timer"
                                />

                                <div className={styles.formRow}>
                                    <FormNumberField
                                        name="countdown_timer_minutes"
                                        label="Timer Minutes"
                                        placeholder="5"
                                        min={1}
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                </FormLayout>
            </Collapsible>
        </>
    );
};

export default BundleInfo;
